<template>
  <v-container class="minHeight">
    <v-form
      ref="form"
      v-model="valid"
      v-on:submit.prevent="
        () => {
          return false;
        }
      "
    >
      <v-card>
        <v-card-title class="pa-0">
          <v-toolbar class="secondary" flat card dense>
            <v-toolbar-title class="white--text">
              {{ $t('funds.download.title') }}
            </v-toolbar-title>
          </v-toolbar>
        </v-card-title>
        <v-layout row wrap pa-4>
          <vuetify-from-to-date-selector
            :lang-selected="langSelected"
            @on-dates-selected="datesSelected"
          />
          <v-flex xs12 md4>
            <v-select
              v-model="form.reportType"
              :items="items"
              item-text="name"
              item-value="type"
              :menu-props="{ maxHeight: '400' }"
              :label="$t('funds.download.type')"
              persistent-hint
            ></v-select>
          </v-flex>
          <v-flex xs12 md1>
            <!--v-btn class="right"
                   outline
                   fab
                   small
                   :disabled='!valid'
                   :loading="isLoadingFileDownload"
                   type="submit"
                   @click="downloadReportFile"
                   color="primary">
              <v-icon color="primary">file_download</v-icon>
            </v-btn-->

            <v-btn
              class="right"
              outline
              fab
              small
              :disabled="!valid"
              :loading="isLoadingEmail"
              type="submit"
              @click="sendReportEmail"
              color="primary"
            >
              <v-icon color="primary">email</v-icon>
            </v-btn>
          </v-flex>
        </v-layout>
      </v-card>
    </v-form>
    <v-card>
      <v-card-text class="py-0">
        <v-timeline align-top dense>
          <v-timeline-item
            :color="`funds${item.type}`"
            small
            v-for="(item, index) in list"
            :key="index"
          >
            <v-expansion-panel class="elevation-0" expand>
              <v-expansion-panel-content hide-actions :key="item.id">
                <template v-slot:header>
                  <v-layout wrap style="cursor: pointer">
                    <v-flex xs12 sm3>
                      {{ item.dateCreated | formatDateMaxAvailabilityPark }}
                    </v-flex>

                    <v-flex>
                      <strong> {{ calculeFundTitle(item) }} </strong>
                    </v-flex>

                    <v-flex xs12 sm2>
                      <v-chip
                        class="ma-0"
                        :class="{ right: $vuetify.breakpoint.smAndUp }"
                        disabled
                        outline
                        :color="getAmountColor(item)"
                        small
                        >{{ item.amountPrettyFormat }}</v-chip
                      >
                    </v-flex>
                  </v-layout>
                </template>

                <funds-buy v-if="isPayment(item)" :funds="item"> </funds-buy>

                <funds-booking v-else-if="isBooking(item)" :funds="item">
                </funds-booking>

                <funds-register v-else-if="isRegister(item)" :funds="item">
                </funds-register>

                <funds-letter v-else-if="isLetter(item)" :funds="item">
                </funds-letter>

                <funds-gift v-else-if="isGift(item)" :funds="item">
                </funds-gift>
              </v-expansion-panel-content>
            </v-expansion-panel>
          </v-timeline-item>
        </v-timeline>
      </v-card-text>
    </v-card>

    <infinite-loading @infinite="infiniteHandler">
      <template slot="no-more">&nbsp;</template>
    </infinite-loading>
  </v-container>
</template>

<script>
// TODO: si se entra directo al detalle de un parking, el botón atras te saca fuera, igual se puede mirar que el hostname sea wesmartpark
import InfiniteLoading from 'vue-infinite-loading';
import fundsService from '@/services/fundsService';
import FundsBuy from '@/components/private/funds/FundsBuy';
import FundsBooking from '@/components/private/funds/FundsBooking';
import FundsRegister from '@/components/private/funds/FundsRegister';
import FundsLetter from '@/components/private/funds/FundsLetter';
import FundsGift from '@/components/private/funds/FundsGift';
import ticketService from '@/services/ticketService';
import manageErrorService from '@/services/manageErrorService';
import store from '@/store';
import VuetifyFromToDateSelector from '@/components/commons/VuetifyFromToDateSelector.vue';
import keys from '@/store/keys';
import { EventBus } from '@/services/eventBus';
import _ from 'lodash';

export default {
  name: 'Funds',
  components: {
    InfiniteLoading,
    [FundsBuy.name]: FundsBuy,
    [FundsBooking.name]: FundsBooking,
    [FundsRegister.name]: FundsRegister,
    [FundsLetter.name]: FundsLetter,
    [FundsGift.name]: FundsGift,
    [VuetifyFromToDateSelector.name]: VuetifyFromToDateSelector,
  },
  computed: {
    langSelected() {
      return store.state.langSelected;
    },
    username() {
      return store.state.user.username;
    },
  },
  data() {
    return {
      page: 0,
      list: [],
      valid: false,
      isLoadingFileDownload: false,
      isLoadingEmail: false,
      form: {
        start: null,
        end: null,
      },
      items: [
        { type: 'tickets', name: this.$i18n.t('funds.download.type.tickets') },
        {
          type: 'payments',
          name: this.$i18n.t('funds.download.type.payments'),
        },
        {
          type: 'bookings',
          name: this.$i18n.t('funds.download.type.bookings'),
        },
      ],
    };
  },
  methods: {
    // TODO: hay que actualizar la base de datos para actualizar a todos el campo `buyType`
    calculeFundTitle(fund) {
      let fundTitle = '';
      if (fund.reservation && fund.reservation.plan != null) {
        fundTitle =
          this.$i18n.t('global.subscription') +
          ': ' +
          fund.reservation.plan.name;
      } else {
        fundTitle = fund.title;
      }
      return fundTitle;
    },
    async infiniteHandler(state) {
      let params = {
        sortBy: 'dateCreated',
        start: this.page * 10,
        length: 10,
      };
      let resp = await fundsService.list(params);
      this.page += 1;
      let newRows = _.map(resp.data.data, (element) => {
        let title = '';
        if (element.type === 'DEPOSIT_BUY') {
          title = this.$i18n.t(`funds.${element.type}_${element.buyType}`);
        } else {
          title = this.$i18n.t(`funds.${element.type}`);
        }

        return _.extend({}, element, { title: title });
      });

      this.list.push(...newRows);
      state.loaded();
      if (resp.data.data.length === 0) {
        state.complete();
      }
    },

    getAmountColor(item) {
      if (parseFloat(item.amount) > 0) {
        return 'green';
      }
      return 'red';
    },

    isRegister(item) {
      return (
        ['DEPOSIT_REGISTER', 'DEPOSIT_SIMPLE_REGISTER'].indexOf(item.type) > -1
      );
    },

    isPayment(item) {
      return (
        ['DEPOSIT_BUY', 'DEPOSIT_PROMO', 'DEPOSIT_PROMO_FREE'].indexOf(
          item.type
        ) > -1
      );
    },

    isBooking(item) {
      return (
        [
          'WITHDRAWAL_SUBSCRIPTION_OLD',
          'WITHDRAWAL_SUBSCRIPTION_NIGHT',
          'WITHDRAWAL_SUBSCRIPTION_DAY',
          'WITHDRAWAL_SUBSCRIPTION_WEEK',
          'WITHDRAWAL_SUBSCRIPTION_MONTH',
          'WITHDRAWAL_SUBSCRIPTION_CUSTOM',
          'WITHDRAWAL_SUBSCRIPTION_MULTI',
          'WITHDRAWAL_USE',
        ].indexOf(item.type) > -1
      );
    },

    isLetter(item) {
      return item.type === 'WITHDRAWAL_ITEM';
    },

    isGift(item) {
      return item.type === 'DEPOSIT_HOSTESS';
    },

    async datesSelected(params) {
      this.form.start = params.start;
      this.form.end = params.end;
    },
    async downloadReportFile() {
      this.isLoadingFileDownload = true;
      let results = await ticketService.downloadReportFile(
        this.form,
        this.$i18n.t(`funds.download.type.${this.form.reportType}`)
      );

      if (results.error) {
        manageErrorService.handle(results.data);
        this.isLoadingFileDownload = false;
        this.valid = true;
        return;
      }

      this.isLoadingFileDownload = false;
      this.valid = true;
    },
    async sendReportEmail() {
      this.isLoadingEmail = true;
      let results = await ticketService.sendReportEmail(this.form);

      if (results.error) {
        manageErrorService.handle(results.data);
        this.isLoadingEmail = false;
        this.valid = true;
        return;
      }

      EventBus.$emit(keys.eventOnShowNotification, {
        title: '',
        message: this.$i18n.t('ticket.toast.success', {
          username: this.username,
        }),
        type: 'info',
        doNotTranslate: true,
      });

      this.isLoadingEmail = false;
      this.valid = true;
    },
  },
};
</script>

<style>
form div.v-card {
  margin-bottom: 10px !important;
}
form div.md4 .v-select {
  margin-left: 30px;
}
</style>
